import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import ForestOutlinedIcon from '@mui/icons-material/ForestOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum TrailStewardSectionIds {
  general = 'general',
  systems = 'systems',
}

/**
 * @description Sections shared by the Trail Steward detail page and edit form, in display order.
 * `systems` is read-only: it is shown on the detail page only, since stewards are assigned from each trail
 * system's edit form.
 */
export const trailStewardSections: SectionDefinition[] = [
  {
    id: TrailStewardSectionIds.general,
    title: 'General',
    description: 'Organization name and how to contact them.',
    icon: InfoOutlinedIcon,
  },
  {
    id: TrailStewardSectionIds.systems,
    title: 'Trail Systems',
    description: 'Trail systems this steward maintains. Assign stewards from the trail system edit form.',
    icon: ForestOutlinedIcon,
  },
]
